module.exports = __webpack_public_path__ + "img/6.3cdf5275.webp";